export const LOAFERS_BRAND = {
  businessName: "Loafers Home Bakery",
  shortName: "Loafers",
  ownerAppName: "Loafers Command",
  tagline: "Handcrafted bread. Made at home.",
  extendedTagline: "Real ingredients. Honest baking. From our home to yours.",
  badgeSrc: "./brand/loafers-home-bakery-badge.png",
  bannerSrc: "./brand/loafers-home-bakery-banner-hero.jpg",
};
